import { computed } from 'vue'

export const annotationMixin = (store: any) => {
  const options = computed(() => store.state.topoProfilePoint.options)
  const items = computed(() => store.state.topoProfilePoint.items || [])

  const getDisplayName = (name?: string) =>
    options.value?.name?.choices?.find((c: any) => c?.value === name)?.display_name

  const annotations = computed(() =>
    items.value
      .filter((item: any) => item?.properties?.name)
      .map((item: any) => {
        const displayName = getDisplayName(item.properties.name) ?? item.properties.name
        return {
          x: item.geometry.coordinates[0],
          y: item.geometry.coordinates[1],
          yshift: 10,
          yanchor: 'bottom',
          textangle: '90',
          bgcolor: 'white',
          text: displayName,
          showarrow: false,
          ay: 40,
          hideToggle: true
        }
      })
  )
  return {
    options,
    items,
    annotations,
    getDisplayName
  }
}
